import { defineComponent as _defineComponent } from 'vue'
import {
  reactive,
  ref,
  computed,
  watch,
  onMounted,
  getCurrentInstance,
} from "vue";

// Props
type PropTypes = {
  items: unknown[];
  initial_highlighted_index?: number;
  dropdown_height?: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'dropdown',
  props: {
    items: null,
    initial_highlighted_index: { default: 0 },
    dropdown_height: { default: "auto" }
  },
  setup(__props: any, { expose, emit }: { emit: ({
  item_selected: [item: unknown];
}), expose: any, slots: any, attrs: any }) {

const props = __props as { items: unknown[], initial_highlighted_index: number, dropdown_height: string };



// Emits


// Get current instance to access $slots
const instance = getCurrentInstance();

// Reactive state object
const state = reactive({
  highlighted_index: 0,
  items: [] as unknown[],
  is_open: false,
});

// Computed properties
const current_highlighted_index = computed(() => {
  return state.highlighted_index;
});

// Watch for items prop changes
watch(
  () => props.items,
  (new_val: unknown[], old_val: unknown[]) => {
    state.items = new_val;
    if (
      state.highlighted_index >= state.items.length &&
      state.items.length > 0
    ) {
      state.highlighted_index = state.items.length - 1;
    }
  },
);

// Methods
const show = () => {
  state.is_open = true;
};

const hide = () => {
  state.is_open = false;
};

const choose_item_from_dropdown_menu = (
  item_selected: unknown,
  index: number,
) => {
  state.highlighted_index = index;
  emit("item_selected", item_selected);
  hide();
};

const move_highlighted = (event: KeyboardEvent) => {
  if (event.code === "Enter" && state.is_open && state.items.length > 0) {
    event.preventDefault();
    event.stopPropagation();
    choose_item_from_dropdown_menu(
      state.items[state.highlighted_index],
      state.highlighted_index,
    );
  } else if (event.code === "ArrowDown") {
    event.preventDefault();
    event.stopPropagation();

    show();

    if (state.highlighted_index < state.items.length - 1) {
      state.highlighted_index += 1;
    }
  } else if (event.code === "ArrowUp") {
    event.preventDefault();
    event.stopPropagation();

    show();

    if (state.highlighted_index > 0) {
      state.highlighted_index -= 1;
    }
  } else if (event.code === "Escape") {
    hide();
  }
};

// Lifecycle - equivalent to created()
state.items = props.items;
state.highlighted_index = props.initial_highlighted_index;

// Lifecycle - equivalent to mounted()
onMounted(() => {
  if (!instance || !instance.proxy || !instance.proxy.$slots.header) {
    throw Error('Missing required slot: "header"');
  }

  // Access slots through the instance proxy (Vue 2.7 style)
  const headerSlot = instance.proxy.$slots.header;
  if (!headerSlot || !headerSlot[0] || !headerSlot[0].elm) {
    throw Error("Header slot element not found");
  }

  const header_slot_content = headerSlot[0].elm as HTMLElement;

  header_slot_content.addEventListener("blur", () => {
    hide();
  });

  header_slot_content.addEventListener("click", () => {
    state.is_open = !state.is_open;
  });
});

// Expose state and methods for external access (tests, parent components)
expose({
  state,
  current_highlighted_index,
  show,
  hide,
});

return { __sfc: true,props, emit, instance, state, current_highlighted_index, show, hide, choose_item_from_dropdown_menu, move_highlighted }
}

})